import { connect } from 'react-redux';
import { getActivitiesByObjectiveId } from '@/core/slices/activities';
import { getRequirements } from '@/core/slices/requirements';
import { fetchObjectivesByVersionId } from '@/core/slices/objectives';
import { fetchAllFocuses, fetchFocusesFulfillmentProgress } from '@/core/slices/focuses';
import {
  addFocusFulfillmentValidation,
  addPlanValidation,
  getPlanValidation,
  uploadPlanSignature,
  getFocusFulfillmentValidationsThunk,
} from '@/core/slices/plans';
import {
  objectives,
  activities,
  requirements,
  focuses,
  currentVersion,
  currentFulfillmentVersion,
  readOnlyMode,
  isLoadingFocuses,
  checklists,
  selectedYear,
  scopeName,
  currentPlanId,
  currentBusinessUnit,
} from '../../../../../../core/selectors';
import {
  fetchChecklistsByVersionId,
  fetchChecklistResponsesByVersionId,
} from '@/core/slices/checklists';
import { RootState } from '@/core/types/state';
import CEOValidation from '../../../../components/AnnualPlanning/SecondTerm/CEOValidation.tsx';

const ConnectedCEOValidation = connect(
  (state: RootState) => ({
    objectives: objectives(state),
    activities: activities(state),
    requirements: requirements(state),
    focuses: focuses(state),
    currentVersion: currentVersion(state),
    currentPlanId: currentPlanId(state),
    currentFulfillmentVersion: currentFulfillmentVersion(state),
    readOnlyMode: readOnlyMode(state),
    focusesLoading: isLoadingFocuses(state),
    checklistResponses: state.checklists.responses || [],
    checklists: checklists(state),
    selectedYear: selectedYear(state),
    scopeName: scopeName(state),
    currentBusinessUnit: currentBusinessUnit(state),
    planValidation: state.plans.planValidation,
    focusFulfillmentValidations: state.plans.focusFulfillmentValidations,
  }),
  {
    fetchObjectivesByVersionId,
    getActivitiesByObjectiveId,
    getRequirements,
    fetchAllFocuses,
    fetchFocusesFulfillmentProgress,
    addFocusFulfillmentValidation,
    addPlanValidation,
    getPlanValidation,
    uploadPlanSignature,
    getFocusFulfillmentValidationsThunk,
    fetchChecklistsByVersionId,
    fetchChecklistResponsesByVersionId,
  },
)(CEOValidation);

export default ConnectedCEOValidation;
